// Add :external selector
$.expr[':'].external = function(obj){
	return (!obj.href.match(/^mailto\:/)
	&& (obj.hostname != location.hostname)
	&& !obj.href.match(/^javascript\:/)
	&& !obj.href.match(/^$/))
	|| obj.href.match(/\.pdf$/)
};

var home;
var invest;
var account;

$(document).ready(function(){

	// IMV-337 - Insertion des trackers

	// A déclencher une fois que le formulaire de création de compte est correctement complété et envoyé (Step 1 avec les données démographique).
		$('.quform-form-8').on('quform:goToPageStart', function (e, form, $page, id, targetPageIndex) {
        if(targetPageIndex == 1){
					gtag('event', 'Création compte - Step 1', {'event-category': 'Envoi formulaire' ,'event_label': 'Suivant' });
				}
    });

	//A déclencher une fois que le formulaire de confirmation de compte est correctement complété et envoyé (Step 2 le code de téléphone)
		$('.quform-form-8').on('quform:successStart', function (e, form, confirmation) {
				gtag('event', 'Création compte - Step 2', {'event-category': 'Envoi formulaire' ,'event_label': 'Créer mon compte' });
	});
	
	// FatNav
	$.fatNav();

	// Add target _blank
	$('a:external').attr('target', '_blank');

	if (!vars.logged_in)
		loginPopup();

	home = $('.home').length;
	invest = $('.page-template-template-invest').length;
	account = $('.page-template-template-account').length;
	settings = $('.page-template-template-settings').length;
	create = $('.page-template-template-create-account').length;
	transactions = $('.section-transactions').length;


	fields();
	connexion();
	contactAdvisor();
	popupNewsletter();
	protectedLink();
	voirBien();
	checkGet();
	if($('.teasing-countdown').length){
		countdown();
	}
	if (home){
		homeHeaderSlider();
		propertySlider();
		homeHeader();
		//headerColorFromVideo();
	}

	if (invest){
		propertySlider();
		howTo();
	}

	if (account){
		propertySlider();
		$('.quform-field-checkbox').click(function(e){
			$(this).toggleClass('checked');
		});
	}

	if (create || settings){
		formatPhoneNumber();
	}

	if (settings){
		propertySlider();
	}

	if ($('.section-actions').length)
		sectionActions();

	if ($('.simulation').length)
		simulation();

	if ($('.page-template-template-contact').length)
		showNL();

	if ($('.buxum-slider').length)
		buxumSlider();

	if ($('.video-wrapper').length)
		initVideos();

	if ($('.toggle').length)
		toggle();

	if ($('.property-navigation-bar').length)
		propertyNavInit();

	if ($('.faq-accordion').length)
		faq();

	if ($('.page-template-template-formation').length)
		formations();

	if ($('.blog').length){
		blog();
	}

	if($('.quform-8').length){
		createAccountForm();
	}

	if($('.quform-11').length){
		settingsForm();
	}
	if(transactions){
		transactionsFX();
	}
	if($('.section-transactions').length){
		// Filtre date
		$('#transaction-date').change(function(e){
			var optionSelected = $("option:selected", this);
    	var valueSelected = this.value;
			var year = valueSelected.substr(3, 4);
			var month = valueSelected.substr(0, 2);

			$('.section-transactions .property').hide();

			if (valueSelected == "all"){
					$('.section-transactions .property').show();
			}
			else{
					$(".property[data-year='" + year + "'][data-month='" + month + "']").show();
			}

		})
	}

	if($('.processes').length){
		$('.processes .cols').addClass("owl-carousel owl-theme").owlCarousel({
		    loop:true,
		    margin:5,
		    nav:false,
		    dots:false,
		    stagePadding: 25,
		    responsive:{
		        0:{
		            items:1,

		        },
		        991:{
		            items:3
		        },
		    }
		});
	}

	$('#delete-account').click(function(e){
		$('.quform-popup-link-15').click();
	})

})

var player;

// function getAuthorizationCode(){
// 	return "d89fed6e-ac61-4b06-a5d7-7914d42f8d42";
// }
// function getAccessToken(){
// 	$.ajax({
// 	  url:"https://api.hubapi.com/oauth/v1/token",
// 	  type:"POST",
// 	  grant_type : "authorization_code",
// 	  client_id : "20ec7b0d-ed83-4a64-a70b-e9e90365c39c",
// 	  client_secret : "a660ad3a-b5e1-4c8f-a03b-86ed48bd1e2d",
// 	  redirect_uri : "https://www.imvesters.ch",
// 	  code : "d89fed6e-ac61-4b06-a5d7-7914d42f8d42",
// 	  contentType:"application/x-www-form-urlencoded",
// 	  dataType:"json",
// 	  success: function(result){
// 	    console.log(result);
// 	  },
// 	  error: function(error){
// 	    console.log(error);
// 	  }
// 	})
// }

// function countdown(){
// 	const second = 1000,
//       minute = second * 60,
//       hour = minute * 60,
//       day = hour * 24;

// let countDown = new Date('Sep 16, 2019 16:00:00').getTime(),
//     x = setInterval(function() {

//       let now = new Date().getTime(),
//           distance = countDown - now;

//       document.getElementById('days').innerText = Math.floor(distance / (day)),
//         document.getElementById('hours').innerText = Math.floor((distance % (day)) / (hour)),
//         document.getElementById('minutes').innerText = Math.floor((distance % (hour)) / (minute)),
//         document.getElementById('seconds').innerText = Math.floor((distance % (minute)) / second);
//         $('.temporary-header').css("opacity", 1);
      
//     }, second)
// }

function transactionsFX(){

	$('.revenu-filters span').click(function(e){
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		setDetails();
		$(this).parent().parent().parent().addClass("active");
		e.stopPropagation();
	})


	setDetails();

	function setDetails(){
		$('.section-transactions .invest-entry').each(function(e){

			var factor;
			var activeFilter = $(this).find('.revenu-filters span.active').index();
			var years = parseInt($(this).attr("data-period"));
			var equity = parseInt($(this).attr("data-equity"));

			switch(activeFilter) {
			  case 0:
			    factor = 1;
			    break;
			  case 1:
			   factor = 1 / years;
			    break;
			   case 2:
			   factor = (1 / years) / 12;
			    break;
			  default:

			}

			var amount = factor * parseInt($(this).attr("data-amount"));

			var revenueDistribue = amount * (equity - 1)/100 * years;
			var provision = amount * 1/100 * years;
			var revenuTotal = amount * equity/100 * years;

			$(this).find('.number-1').text(parseInt(revenueDistribue).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

			$(this).find('.number-2').text(parseInt(provision).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
			$(this).find('.number-3').text(parseInt(revenuTotal).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

		})
	}

}
function checkGet(){
	var getUrlParameter = function getUrlParameter(sParam) {
	    var sPageURL = window.location.search.substring(1),
	        sURLVariables = sPageURL.split('&'),
	        sParameterName,
	        i;

	    for (i = 0; i < sURLVariables.length; i++) {
	        sParameterName = sURLVariables[i].split('=');

	        if (sParameterName[0] === sParam) {
	            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
	        }
	    }
	}
	var redirect = getUrlParameter('redirect');

	if (redirect != null && redirect != true && $.isNumeric(redirect)){
		console.log("do");
		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
            	'id' : parseInt(redirect),
                'action': 'redirectToID'
            }, success: function (result) {
            	window.location.href = result;
            },
            error: function () {
                console.log("error");
            }
    	});
	}
	else{
		var onlyUrl = window.location.href.replace(window.location.search,'');
		history.pushState("", "", onlyUrl );
		// window.history.replaceState({}, onlyUrl, "/" );
	}
}

function voirBien(){
	$('a.type-property').click(function(e){
		e.preventDefault();

		var href = $(this).attr('href');
		var redirect = $(this).attr("data-redirect");
		// $('.quform-field-9_11').val(redirect);
		$('.quform-field-9_11').val(redirect);
		event.preventDefault();

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'action': 'checkConnexion'
            }, success: function (result) {
            	var result = result.replace(/\s+/g, '');
               if (result == "true"){
               		location.href = href;
               }
               else{
	               	$("body").addClass("login-popup");
               }
            },
            error: function () {
                console.log("error");
            }
    	});


	});
}

function checkConnexionButtonHeader(){
	$('a.introduction-bottom').on('click', function(event){
		var href = $(this).attr('href');
		if (href.indexOf("mon-compte") >= 0){
			event.preventDefault();

			$.ajax({
	            type: 'POST',
	            url: ajaxurl,
	            data: {
	                'action': 'checkConnexion'
	            }, success: function (result) {

	               if (result == "true"){
	               		location.href = href;
	               }
	               else{
		               	$("body").addClass("login-popup")
						$('body').toggleClass('darken');
	               }
	            },
	            error: function () {
	                console.log("error");
	            }
        	});
		}

	});
}

function formatPhoneNumber(){
	var cleave = new Cleave('.phone', {
    	phone: true,
    	phoneRegionCode: 'CH'
	});
}

function homeHeader(){
	headerIntroductionHeight();

	var video = $('.header-video .video');
	player = video.get(0);
	video.on('loadedmetadata', function(){
		homeHeaderSlidesHeight();
	});
	$(window).on('resize', headerIntroductionHeight);

	function headerIntroductionHeight(){
		var videoH = $('.slide-video .video').outerHeight();
		$('.slide-video .introduction').css('min-height', videoH + 90);
		var chartH = $('.slide-simulator .header-content').outerHeight();
		$('.slide-simulator .introduction').css('min-height', videoH + 90);
	}
}

function popupNewsletter(){
	$('a').on('click', function(event){
		var href = $(this).attr('href');
		if (href.indexOf("newsletter") >= 0){
			event.preventDefault();

			$('body').addClass("newsletter-popup");
			$('body').addClass("darken");
		}
	});
	$('.popup-newsletter .close').click(function(e){
		$('body').removeClass("newsletter-popup");
		$('body').removeClass("darken");
	});
}

function protectedLink(){
	$('a:not(.type-property)').on('click', function(event){
		var href = $(this).attr('href');
		
			event.preventDefault();

			$.ajax({
	            type: 'POST',
	            url: ajaxurl,
	            data: {
	            	'href' : href,
	                'action': 'protectedLink'
	            }, success: function (result) {


	               if (result == "null"){
	               		location.href = href;
	               }
	               
	               else{
		               	$("body").addClass("login-popup")
						$('body').toggleClass('darken');

						$('.quform-field-9_11').val(result);
	               }
	            },
	            error: function () {
	                console.log("error");
	            }
        	});
	

	});
}
function fields(){
	$('.field input, .field select, .field textarea, .quform-element-text input, .quform-element-email input, .quform-element-date input, .quform-element-textarea textarea, .quform-element-radio input, .quform-element-checkbox input').on('focus', function(){
		$(this).closest('.field, .quform-element').addClass('focus');
	})

	$('.field input, .field select, .field textarea, .quform-element-text input, .quform-element-email input, .quform-element-date input, .quform-element-textarea textarea, .quform-element-radio input, .quform-element-checkbox input').on('blur', function(){
		$(this).closest('.field, .quform-element').removeClass('focus');
	})

	// Check if empty on ready
	$('.field input, .field select, .field textarea, .quform-element-text input, .quform-element-email input, .quform-element-date input, .quform-element-textarea textarea').each(function(){
		if ($(this).val() != '' && 'radio' != $(this).attr('type'))
			$(this).closest('.field, .quform-element').addClass('not-empty');
	})

	// Add/remove not-empty class on typing
	$('.field input, .field select, .field textarea, .quform-element-text input, .quform-element-email input, .quform-element-date input, .quform-element-textarea textarea, .quform-element-password input').on('input change', function(){
		if ($(this).val() != '' && 'radio' != $(this).attr('type'))
			$(this).closest('.field, .quform-element').addClass('not-empty');
		else
			$(this).closest('.field, .quform-element').removeClass('not-empty');
	})

	$('textarea').attr('rows', 1);
	$('textarea').on('focus', function(){
		var savedValue = this.value;
		this.value = '';
		this.baseScrollHeight = this.scrollHeight;
		this.value = savedValue;
	}).on('input', function(){
		var minRows = 1, rows;
		this.rows = minRows;
		rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 48);
		this.rows = minRows + rows;
	});
}

function connexion(){
	$('.connexion a').click(function(e){
		e.preventDefault();
		$("body").addClass("login-popup")
		$('body').toggleClass('darken');
		$('.quform-field-9_11').val("");
	});

	$('.quform-element-9_9').click(function(e){
		$('body').removeClass('darken');
		$("body").removeClass("login-popup")
	});

	$('.quform-element-8_4 a').click(function(e){
		e.preventDefault();
		$('body').addClass('darken');
	});
}


function homeHeaderSlider(){
	var currentSlide = 0;

	homeHeaderSlidesHeight();
	$(window).on('resize', homeHeaderSlidesHeight);

	// Règles un peu wtf pour compenser le fait que le slider soit pas dynamique...
	// Se base sur l'ajout de la classe offset3 pour le troisième élément du slider

	$('.header-slider-nav .prev').on('click', function(){
		currentSlide--;
		gotoSlide();
	});

	$('.header-slider-nav .next').on('click', function(){
		currentSlide++;
		gotoSlide();
	});

	$('.header-slider-nav .index-1').on('click', function(){
		currentSlide = 0;
		gotoSlide();
	});

	$('.header-slider-nav .index-2').on('click', function(){
		currentSlide = 1;
		gotoSlide();
	});

	$('.header-slider-nav .index-3').on('click', function(){
		currentSlide = 2;
		gotoSlide();
	});

	function gotoSlide(){
		console.log(currentSlide);
		if ( currentSlide === 3 ) currentSlide = 0;
		if ( currentSlide === -1 ) currentSlide = 3;
		console.log(currentSlide);

		if (0 == currentSlide){
			if (player.paused)
				player.play();
			$('.header-slider, .header-slider-nav').removeClass('slided offset3');
		}else if (1 == currentSlide){
			if (!player.paused)
				player.pause();

			$('.header-slider, .header-slider-nav').addClass('slided');
			$('.header-slider, .header-slider-nav').removeClass('offset3');
		}
		else if (2 == currentSlide){
			if (!player.paused)
				player.pause();

			$('.header-slider, .header-slider-nav').addClass('slided offset3');
		}
	}
}

function homeHeaderSlidesHeight(){
	var slideH = 0;
	$('.header-slider .header-content').each(function(){
		var thisH = $(this).outerHeight(true);
		if (thisH > slideH)
			slideH = thisH;
	})

	//$('.header-slider .introduction').css('height', slideH);
}

function propertySlider()
{
	// Ouverture des popups custom pour chaque type de bien
	$('.financed, .interested, .incoming').click(function (e) {
		// On met à jour la valeur du statut du bien dans le formulaire
		var statutBien = $(this).data('statutBien');

		var self = $(this);
		$('input[name="quform_5_31"]').val(statutBien);

		e.preventDefault();

		if ($('body.logged-in').length)
		{
			// Pending - Ask for documents
			if ( statutBien === 'incoming' ) $('.quform-popup-link-16').click();
			else $('.quform-popup-link-13').click();

			var property_id = self.parent().attr("data-redirect");
			$('.quform-field-13_4').val(property_id);
		}
		else
		{
			$('.quform-popup-link-12').click();
		}

		return false;
	});

	var currentSlide = 0;
	var nbSlide = $('.property-slide').length;

	$('.property-slider-nav-item, .property-slide').on('click', function(event){
		if ($(this).hasClass('active'))
			return true;

		event.preventDefault();

		currentSlide = $(this).index();
		gotoSlide(currentSlide, 'click');
	})

	$('.property-slider-prevnext .next').on('click', function(){
		currentSlide += 1;
		gotoSlide(currentSlide, 'click');
	})

	$('.property-slider-prevnext .prev').on('click', function(){
		currentSlide -= 1;
		gotoSlide(currentSlide, 'click');
	})

	// Autoslide
	var autoSlideTimeout = false;
	autoNext();
	function autoNext(){
		$('.property-slider-nav-item').eq(currentSlide).addClass('loading').siblings().removeClass('loading');
		autoSlideTimeout = setTimeout(function(){
			if (currentSlide+1 >= nbSlide)
				currentSlide = 0;
			else
				currentSlide += 1;

			gotoSlide(currentSlide, 'auto');
			autoNext();
		}, 5000)
	}

	function gotoSlide(currentSlide, event){
		if ('click' == event && autoSlideTimeout){
			clearTimeout(autoSlideTimeout);
			autoSlideTimeout = false;
			$('.property-slider-nav-item').addClass('full');
		}

		var currentSlideDiv = $('.property-slide').eq(currentSlide);
		currentSlideDiv.addClass('active').siblings().removeClass('active')
		var move = currentSlideDiv.outerWidth(true);
		$('.property-slider-inner').css('transform', 'translate(-'+(move*currentSlide)+'px)')

		$('.property-slider-nav-item').eq(currentSlide).addClass('active').siblings().removeClass('active');

		if (currentSlide <= 0){
			$('.property-slider-prevnext .prev').addClass('disabled');
		}else{
			$('.property-slider-prevnext .prev').removeClass('disabled');
		}

		if (currentSlide+1 >= nbSlide){
			$('.property-slider-prevnext .next').addClass('disabled');
		}else{
			$('.property-slider-prevnext .next').removeClass('disabled');
		}
	}

	// Swipe
	$( document ).on( "swipeleft", ".property-slider-inner", function( event ) {
      	var current = $('.property-slider-nav-item.active');
		var next = current.next();

		if(!next.length){
			next = $('.property-slider-nav-item:first-child');
			console.log(next);
		}
		next.trigger("click");




    });
	$( document ).on( "swiperight", ".property-slider-inner", function( event ) {
      	var current = $('.property-slider-nav-item.active');
		var prev = current.prev();
			prev.trigger("click");
    });


}
function howTo(){

	loadSlide(0);

	$('.slider-nav li').click(function(e){
		var index = $(this).index() - 1;
		var liHeight = $(this).height();
		$('.slider-nav .indicator').css('transform', 'translateY('+(index * liHeight)+'px)')
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		loadSlide(index);
	});

	function loadSlide(index){
		var index = index

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'index': index,
                'action': 'loadSlide'
            }, success: function (result) {
               $('.ajaxContainer').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
        });
	}
}
function showNL(){
	var nl = $('#colophon .newsletter');
	$('.introduction-bottom').on('click', function(){
		$('html, body').stop().animate({ scrollTop: nl.offset().top }, 300, function(){
			$('#newsletter-form-submit').focus();

			nl.addClass('active');
			setTimeout(function(){
				nl.removeClass('active');
			}, 300)
		})
	})
}

function createAccountForm()
{
	var tokenReference = 1 + Math.floor(Math.random() * 100000);

	/* Check credits */
	$.ajax({
	    url : "https://json.aspsms.com/CheckCredits",
	    type: 'POST',
	    dataType : "json",
	    data: JSON.stringify({
			'UserName':'AP9HJECUCGPF',
			'Password':'ISp35BV7MK7bqOSZefczKd0s'
	    }),
	    success:function(data){
	    	console.log(data);
	    },
	    error: function() {
	    	console.log(data);
	    }
	});

	// /* Verify Token */
	var input = document.querySelector(".phone");
	var form = document.querySelector(".quform-8");

	var iti = intlTelInput(input, {
		autoPlaceholder: "aggresive",
		nationalMode : false,
		autoHideDialCode : false,
		initialCountry: "ch",
		onlyCountries: ["ch"],
	});

	var isSMSsent = false;

	$('.quform-form-8').on('quform:goToPageStart', function (e, form, $page, id, targetPageIndex) {


		$('html,body').animate({
                scrollTop: $('.quform-8').offset().top - 20
        }, 1000);

		var phoneNumber = $('.phone').val();
		if(targetPageIndex == 1 && !isSMSsent){
			isSMSsent = true;
		
			/* SendTokenSMS */
			$.ajax({
				url : "https://json.aspsms.com/SendTokenSMS",
				type: 'POST',
				dataType : "json",
				data: JSON.stringify({
					"UserName": "AP9HJECUCGPF",
					"Password": "ISp35BV7MK7bqOSZefczKd0s",
					"Originator": "+41799172576",
					"Recipients": [phoneNumber],
					"MessageData": "Bienvenue sur la plateforme Imvesters. Voici votre code de confirmation : <VERIFICATIONCODE>",
					"TokenReference": tokenReference,
					"TokenValidity": "",
					"TokenMask": "",
					"VerificationCode": "",
					"TokenCaseSensitive": 0,
					"URLBufferedMessageNotification": "",
					"URLDeliveryNotification": "",
					"URLNonDeliveryNotification": "",
					"AffiliateID": ""
				}),
				success:function(data){
					console.log(data);
				},
				error: function() {
					console.log(data);
				}
			});
		}

		
	});

	$('.quform-button-submit-8_2').click(function(e) {
		e.preventDefault();
		var phoneNumber = $('.phone').val();
		var verificationCode = $('.quform-field-8_23').val();

		// VerifyToken
		$.ajax({
			url : "https://json.aspsms.com/VerifyToken",
			type: 'POST',
			dataType : "json",
			data: JSON.stringify({
					'UserName':'AP9HJECUCGPF',
					'Password':'ISp35BV7MK7bqOSZefczKd0s',
					'PhoneNumber':phoneNumber,
					'TokenReference':tokenReference,
					'VerificationCode':verificationCode
			}),
			success:function(data){
				var statusCode = data['StatusCode'];
				console.log(statusCode);
				console.log(data);
				if (statusCode != 1) {
					alert("Code non valide");
				}
				else {
					e.stopPropagation();
					$('.quform-button-submit-8_2').submit();
				}
			},
			error: function() {
				console.log(data);
			}
		});
	});

	$(".quform-field-8_16").strength({
		strengthClass: 'strength',
		strengthMeterClass: 'strength_meter',
		strengthButtonClass: 'button_strength',
		strengthButtonText: 'Voir le mot de passe',
		strengthButtonTextToggle: 'Cacher le mot de passe'
	});

}

function settingsForm(){

	var input = document.querySelector(".phone");
	var form = document.querySelector(".quform-11");
	var result = document.querySelector(".quform-element-11_14 .quform-spacer");

	var iti = intlTelInput(input, {
		autoPlaceholder: "aggresive",
		nationalMode : false,
		autoHideDialCode : false,
		initialCountry: "ch",
		onlyCountries: ["ch"],
	});


	form.addEventListener("submit", function(e) {
	  e.preventDefault();
	  var num = iti.getNumber(),
	      valid = iti.isValidNumber();

		 // result.textContent = "Number: " + num + ", valid: " + valid;

		  // if (!valid){
		  // 	alert("telephone non valide");
		  // }

	}, false);

	 $(".quform-field-8_16").strength({
        strengthClass: 'strength',
        strengthMeterClass: 'strength_meter',
        strengthButtonClass: 'button_strength',
        strengthButtonText: 'Voir le mot de passe',
        strengthButtonTextToggle: 'Cacher le mot de passe'
    });

}

function faq(){

	// Terms select
	$('select.faq-term').on('change', function() {

		var termID = $(this).val();
        $('.search-term-input').val('');
        $('.pagination').hide();
        if(termID == 0){
        	location.reload();
        }
        else{
        	$.ajax({
	            type: 'POST',
	            url: ajaxurl,
	            data: {
	                'termID': termID,
	                'origin' : "term",
	                'action': 'filterFAQ'
	            }, success: function (result) {
	               $('.faq-accordion').hide().empty().html(result).fadeIn("slow");
	            },
	            error: function () {
	                console.log("error");
	            }
	        });
        }

	});

	// Keywords search
	$( ".search-submit button" ).click(function(event) {
		var keyword = $('.search-term-input').val();
		var text = $('select.faq-term option:first-child').text();
		$('select.faq-term option:first-child').attr("selected",true).text(text);
		$('.pagination').hide();

		if (keyword == ""){
			location.reload();
		}
		else{
			$.ajax({
	            type: 'POST',
	            url: ajaxurl,
	            data: {
	                'keyword': keyword,
	                'origin' : "keyword",
	                'action': 'filterFAQ'
	            }, success: function (result) {
	                $('.faq-accordion').hide().empty().html(result).fadeIn("slow");
	            },
	            error: function () {
	                console.log("error");
	            }
			});
		}

	});

	$(document).keyup(function(event) {
		if ($(".search-term-input").is(":focus") && event.key == "Enter") {
			$( ".search-submit button" ).trigger("click");
		}
	});

	// Accordion
	$(document).on('click', '.tog', function(e) {
		e.preventDefault();

		var $this = $(this);
		$this.toggleClass("opened");
		if ($this.next().hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
		} else {
			// $this.parent().parent().find('li .inner').removeClass('show');
			// $this.parent().parent().find('li .inner').slideUp(350);
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
		}
	});

	// Pagination
	$(document).on('click', '.pagination .page', function(event) {
		var paged = $(this).text();
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		filterFAQ(paged);
	});

	$( ".pagination .fa-arrow-left" ).click(function(event) {
		$('.page.active').prev().trigger("click");
	});

	$( ".pagination .fa-arrow-right" ).click(function(event) {
		$('.page.active').next().trigger("click");
	});

	function filterFAQ(paged){
		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'paged': paged,
                'origin' : "pagination",
                'action': 'filterFAQ'
            }, success: function (result) {
               $('.faq-accordion').hide().empty().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
		});
	}

	$(document).on('click', '.reset', function() {
		location.reload();
	});

}
function formations(){

	// Terms select
	$('select.formation-terms').on('change', function() {

        var termID = $(this).val();
        $('.search-term-input').val('');
        $('.pagination').hide();

  		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'termID': termID,
                'origin' : "term",
                'action': 'filterFormations'
            }, success: function (result) {
               $('.formations').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
        });
    });

    // Keywords search
	$( ".search-submit button" ).click(function(event) {

		var keyword = $('.search-term-input').val();
		var text = $('select.formation-terms option:first-child').text();
		$('select.formation-terms option:first-child').attr("selected",true).text(text);
		$('.pagination').hide();

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'keyword': keyword,
                'origin' : "keyword",
                'action': 'filterFormations'
            }, success: function (result) {
               $('.formations').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
		});

	});

	$(document).keyup(function(event) {
    	if ($(".search-term-input").is(":focus") && event.key == "Enter") {
   			$( ".search-submit button" ).trigger("click");
    	}
	});

	// Pagination
	$(document).on('click', '.pagination .page', function(event) {
		var paged = $(this).text();
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		updateFormations(paged);
	});

	$( ".pagination .fa-arrow-left" ).click(function(event) {
		$('.page.active').prev().trigger("click");
	});

	$( ".pagination .fa-arrow-right" ).click(function(event) {
		$('.page.active').next().trigger("click");
	});

	function updateFormations(paged){
		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'paged': paged,
                'origin' : "pagination",
                'action': 'filterFormations'
            }, success: function (result) {
               $('.formations').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
		});
	}

	// Reset
	$(document).on('click', '.reset', function() {
		location.reload();
	});
}

function blog(){

	// Filter my month
	$('select#month, select#year').on('change', function() {

		var origin = $(this).attr("id");


        var month = parseInt($('select#month').val());
        var year = parseInt($('select#year option:selected').text());

        if (origin == "year"){
        	month = 0;
        	updateFilters(year);
		}
        $('.search-term-input').val('');
        $('.pagination').hide();

  		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'month': month,
                'year' : year,
                'origin' : "date",
                'action': 'filterPosts'
            }, success: function (result) {
               $('.ajax-container').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
        });
    });

    // Keywords search
	$( ".search-submit button" ).click(function(event) {

		var keyword = $('.search-term-input').val();
		var text = $('select.formation-terms option:first-child').text();
		$('select.formation-terms option:first-child').attr("selected",true).text(text);
		$('.pagination').hide();

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'keyword': keyword,
                'origin' : "keyword",
                'action': 'filterPosts'
            }, success: function (result) {
               $('.ajax-container').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
		});

	});

	$(document).keyup(function(event) {
    	if ($(".search-term-input").is(":focus") && event.key == "Enter") {
   			$( ".search-submit button" ).trigger("click");
    	}
	});

	// Pagination
	$( ".pagination .page" ).click(function(event) {
		var paged = $(this).text();
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		updatePosts(paged);
	});

	$( ".pagination .fa-arrow-left" ).click(function(event) {
		$('.page.active').prev().trigger("click");
	});

	$( ".pagination .fa-arrow-right" ).click(function(event) {
		$('.page.active').next().trigger("click");
	});

	function updatePosts(paged){
		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'paged': paged,
                'origin' : "pagination",
                'action': 'filterPosts'
            }, success: function (result) {
               $('.ajax-container').hide().html(result).fadeIn("slow");
            },
            error: function () {
                console.log("error");
            }
		});
	}

	function updateFilters(year){
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'year': year,
                'action': 'updateFilters',
            }, success: function (result) {
               console.log(result);
               $('select#month').empty().html(result).fadeIn("slow");

            },
            error: function () {
                console.log("error");
            }
        });
    }

	// Reset
	$(document).on('click', '.reset', function() {
		location.reload();
	});
}

function buxumSlider(){
	$('.buxum-slider').each(function(){
		var slider = $(this);
		var nbSlide = $('.buxum-slide', slider).length;

		var col = 1;
		var colMatches = /col-(\d)/.exec(slider.attr('class'));
		if (colMatches)
			col = parseInt(colMatches[1]);

		initNav(slider, nbSlide, col);
		initSliderVideos(slider);

		var currentSlide = 0;

		var autoSlideMilliseconds = slider.data('autoslide');
		var autoSlideTimeout = false;
		if (autoSlideMilliseconds){
			autoSlideMilliseconds = parseInt(autoSlideMilliseconds);
			autoSlide();
		}

		$('.buxum-slider-nav-item', slider).first().addClass('active');

		$('.buxum-slider-nav-item', slider).on('click', function(){
			if (autoSlideTimeout){
				clearTimeout(autoSlideTimeout);
				autoSlideTimeout = false;
			}

			var currentSlide = $(this).index();
			gotoSlide(slider, currentSlide, col, nbSlide);
		})

		$('.next', slider).on('click', function(){
			currentSlide += 1;
			gotoSlide(slider, currentSlide, col, nbSlide);
		})

		$('.prev', slider).on('click', function(){
			currentSlide -= 1;
			gotoSlide(slider, currentSlide, col, nbSlide);
		})

		function autoSlide(){
			autoSlideTimeout = setTimeout(function(){
				currentSlide += 1;
				if (currentSlide*col >= nbSlide)
					currentSlide = 0;
				gotoSlide(slider, currentSlide, col, nbSlide);

				autoSlide();
			}, autoSlideMilliseconds);
		}
	})

	function gotoSlide(slider, currentSlide, col, nbSlide){
		// Disable nav if start or end of slider
		var realNbSlide = Math.ceil(nbSlide / col);
		if (currentSlide <= 0){
			$('.prev', slider).addClass('disabled');
		}else{
			$('.prev', slider).removeClass('disabled');
		}

		if (currentSlide+1 >= realNbSlide){
			$('.next', slider).addClass('disabled');
		}else{
			$('.next', slider).removeClass('disabled');
		}

		if (col > 1 && (currentSlide+1)*col >= nbSlide && nbSlide % col !== 0){
			// If there's multiple cols, last slide we may be not be doing a full slide
			var slideMove = 100*currentSlide;
			var oneCol = 100 / col;
			var colsAlone = nbSlide % col;
			var move = slideMove - (5-colsAlone) * oneCol;
		}else{
			var move = 100*currentSlide;
		}

		$('.buxum-slider-inner', slider).css('transform', 'translateX(-'+move+'%)');
		$('.buxum-slider-nav-item', slider).eq(currentSlide).addClass('active').siblings().removeClass('active');

		slider.trigger('sliding', [slider, currentSlide, nbSlide]);
	}

	function initNav(slider, nbSlide, col){
		var navType = slider.data('nav');
		if ('bullet' == navType){
			// Bullets
			var realNbSlide = Math.ceil(nbSlide / col);
			if (realNbSlide > 1){
				var nav = '<div class="buxum-slider-nav-bullet">';
				for (var i = 0; i < realNbSlide; i++) {
					nav += '<span class="buxum-slider-nav-item"></span>';
				}
				nav += '</div>';
				slider.append(nav);
			}
		}else if ('arrow' == navType){
			// Arrows
			if (nbSlide > 0){
				var nav = '<div class="buxum-slider-nav-arrow">';
				nav += '<span class="prevnext prev disabled"></span>';
				nav += '<span class="prevnext next"></span>';

				nav += '<div class="buxum-slider-nav-bar">';
				nav += '<span class="index index-1">1</span>';
				nav += '<span class="index index-2">'+nbSlide+'</span>';
				nav += '<span class="progress-bar"></span>';
				nav += '</div>';
				nav += '</div>';
				slider.append(nav);
				$('.buxum-slider-nav-bar .progress-bar', slider).css('transform', 'scale('+(1/nbSlide)+', 1)');

				slider.on('sliding', function(event, slider, currentSlide, nbSlide){
					$('.buxum-slider-nav-bar .progress-bar', slider).css('transform', 'scale('+((currentSlide+1)/nbSlide)+', 1)');
				})
			}
		}
	}

	function initSliderVideos(slider){
		if (!$('video', slider).length)
			return false;

		$('.video-wrapper', slider).each(function(){
			var video = $(this);
			var videoPlayer = $('video', video).get(0);

			slider.on('sliding', function(){
				if (!videoPlayer.paused){
					videoPlayer.pause();
					video.removeClass('playing');
				}
			})
		})
	}
}

function contactAdvisor(){
	$('.contact-advisor').click(function(e){
		e.preventDefault();

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                'action': 'contactAdvisor'
            }, success: function (result) {
            	console.log(result);
        		$('.popup-contact-advisor .infos').append(result);
        		$('body').addClass('contact-advisor-popup').addClass("darken");
            },
            error: function () {
                console.log("error");
            }
        });

	});

	$(document).on('click', '.popup-contact-advisor .close', function(e) {
		$('.popup-contact-advisor .infos').empty();
		$('body').removeClass('contact-advisor-popup').removeClass("darken");
	});
}

function loginPopup(){
	$('a').on('click', function(event){
		var href = $(this).attr('href');
		if (href && -1 !== href.indexOf(vars.property_path)){
			event.preventDefault();
			openLoginPopup(href);
		}
	});

	$('.trigger-connexion').on('click', function(event){
		event.preventDefault();
		$('.connexion a').trigger("click");
	});

	$('.login-form, .login-form .close').on('click', function(){
		closeLoginPopup();
	})

	$(document).keyup(function(event) {
		if (event.keyCode === 27)
			closeLoginPopup();
	});

	$('.login-form-inner').on('click', function(event){
		event.stopPropagation();
	})
}

function openLoginPopup(redirect){
	// $('body').addClass('login-popup-open');
	$("body").addClass("login-popup")
	$('body').addClass('darken');
}

function closeLoginPopup(redirect){
	// $('body').removeClass('login-popup-open');
	$("body").removeClass("login-popup")
	$('body').removeClass('darken');
}

function initVideos(){
	$('.video-wrapper').each(function(){
		var video = $(this);
		var videoPlayer = $('video', video).get(0);

		video.on('click', function(){
			if (videoPlayer.paused){
				videoPlayer.play();
				video.addClass('playing');
			}else{
				videoPlayer.pause();
				video.removeClass('playing');
			}
		})
	})
}

function toggle(){
	$('.toggle').on('click', function(){
		$(this).toggleClass('active').find('.toggle-body').stop().slideToggle(300).css("display", "block"); // A voir si le display flex était nécessaire ??
		$(this).siblings('.active').removeClass('active').find('.toggle-body').stop().slideUp(300);
	})
}

function propertyNavInit(){
	removeUnusedNav();
	var screenCenter;
	var windowH = $(window).height();
	var sectionsPos = getSectionsPos();
	var lastCurrentSection = '';

	$(window).on('resize', function(){
		windowH = $(window).height();
		sectionsPos = getSectionsPos();
	});


	propertyNav();
	$(window).on('scroll', propertyNav);

	// Click nav
	$('.property-navigation-item').on('click', function(){
		$(window).off('scroll', propertyNav);

		var sectionName = $(this).data('name');
		var scrollTo = $('.section-'+sectionName).offset().top - 15;
		if ($('#wpadminbar').length)
			scrollTo -= $('#wpadminbar').height();

		var sectionI = $('.section-'+sectionName).index();
		$('.property-navigation-item.'+sectionName).addClass('active').siblings().removeClass('active');
		$('.property-navigation-bar').css('transform', 'translateY('+(sectionI*100)+'%)');

		var eventAlreadySet = false;
		$('html, body').stop().animate({ scrollTop: scrollTo }, 300, function(){
			// Html and body fire callback twice, handle that
			if (!eventAlreadySet){
				setTimeout(function(){
					$(window).on('scroll', propertyNav);
				}, 50)
				eventAlreadySet = true;
			}
			setTimeout(function(){
				eventAlreadySet = false;
			}, 50);
		})
	});

	// Select
	$('select.property-navigation').on('change', function(){
		var optionSelected = $("option:selected", this);
		var sectionName = optionSelected.data('name');

		var scrollTo = $('.section-'+sectionName).offset().top - 15;
		$('html, body').stop().animate({ scrollTop: scrollTo }, 600, function(){
		})
	});


	function removeUnusedNav(){
		$('.property-navigation-item').each(function(i){
			var sectionName = $(this).data('name');
			if (!$('.section-'+sectionName).length)
				$(this).remove();
		})
	}

	function propertyNav(){
		screenCenter = getScreenCenter();

		var currentSection = '';
		$.each(sectionsPos, function(i, section){
			// Check if before first section
			if (0 == i && screenCenter < section.top){
				currentSection = section;
				return false;
			}

			if (screenCenter >= section.top && screenCenter <= section.bottom){
				currentSection = section;
				return false;
			}

			if (i+1 == sectionsPos.length){
				currentSection = section;
				return false;
			}
		})

		if (lastCurrentSection != currentSection.name){
			var sectionI = $('.section-'+currentSection.name).index();
			$('.property-navigation-item.'+currentSection.name).addClass('active').siblings().removeClass('active');
			$('.property-navigation-bar').css('transform', 'translateY('+(sectionI*100)+'%)');
			lastCurrentSection = currentSection.name;
		}
	}

	function getScreenCenter(){
		return $(document).scrollTop() + windowH / 2;
	}

	function getSectionsPos(){
		var sectionsPos = [];

		$('.property-navigation-item').each(function(i){
			var sectionName = $(this).data('name');
			var section = $('.section-'+sectionName);
			var top = section.offset().top;
			sectionsPos[i] = {
				name: sectionName,
				top: top,
				bottom: top + section.outerHeight(true),
			}
		})

		return sectionsPos;
	}

}

function headerColorFromVideo(){
	var video = $('#masthead .video');
	var videoElement = video.get(0);
	// Get pixel colors
	if (window.matchMedia("(max-width: 1200px)").matches) {
	  /* The viewport is less than, or equal to, 700 pixels wide */
	}
	else{

		var canvas = $('#masthead .canvas').get(0);
		var ctx = canvas.getContext('2d');


		videoElement.addEventListener('loadedmetadata', function() {
			canvas.width = video.width();
			canvas.height = video.height();
		})

		videoElement.addEventListener('play', function() {
			canvas.width = video.width();
			canvas.height = video.height();
			videoAnimation = requestAnimationFrame(headerColor);
		})
	}	
	function headerColor() {
		ctx.drawImage(videoElement, 0, 0, videoElement.clientWidth, videoElement.clientHeight);

		var imageData = ctx.getImageData(0,0,canvas.width, canvas.height);
		var data = imageData.data;
		for (var i = 0; i < data.length; i += 4) {
			var rgb = data[i]+ data[i + 1] + data[i + 2];
			if(rgb < 70){
				data[i + 3] = 0; // alpha
			}
		};
		ctx.putImageData(imageData, 0, 0);

		if (!videoElement.paused && !videoElement.ended) {
			videoAnimation = requestAnimationFrame(headerColor);
		}
	}
}

function sectionActions(){
	var currentModal = false;
	var actionModal = $('.action-modal');

	// setModalHeight();
	// $(window).on('resize', setModalHeight);

	$('.section-actions .action').on('click', function(){

		currentModal = $(this).data('name');

		actionModal.addClass('open '+currentModal);
		setModalHeight();
	})

	// Prevent close on content click
	$('.action-modal-content').on('click', function(event){
		event.stopPropagation();
	})

	actionModal.on('click', closeModal);
	$('.close', actionModal).on('click', closeModal);

	function closeModal(){
		actionModal.removeClass('open '+currentModal);
	}

	// Slide
	$('.goto-documents').on('click', function(){
		$('.action-modal-content', actionModal).addClass('transition');
		setTimeout(function(){
			$('.action-modal-content', actionModal).removeClass('transition');
		}, 350)
		actionModal.removeClass(currentModal);
		currentModal = $('.section-actions .action').eq(1).data('name');
		actionModal.addClass(currentModal);

		// Scroll to top
		actionModal.stop().animate({ scrollTop: 0 }, 300)
		setModalHeight();
	})

	// On form success
	$('.quform-form', actionModal).on('quform:successStart', function(e, form, confirmation){
		console.log(e)
		console.log(form)
		console.log(confirmation)
	})

	function setModalHeight(){

		if (!currentModal)
			return false;
		// $('.action-modal-content', actionModal).css('min-height', $('.'+currentModal).outerHeight());
		// $('.action-modal-inner', actionModal).css('max-height', $('.'+currentModal).outerHeight());
	}


}
